import styled from 'styled-components';
import { theme } from '../../../theme';
import { BaseContainer } from '../../BaseContainer';
const commonStyles = `
  position: fixed;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const Container = styled(BaseContainer).withConfig({ displayName: "vui--Container", componentId: "vui--1xg3v52" }) `${commonStyles} display:${(props) => (props.shouldShow ? 'initial' : 'none')};z-index:${theme.layers.modal};`;
export const Shadow = styled(BaseContainer).withConfig({ displayName: "vui--Shadow", componentId: "vui--nz3cc" }) `${commonStyles} background-color:rgba(55,66,77,0.5);`;
export const Wrap = styled(BaseContainer).withConfig({ displayName: "vui--Wrap", componentId: "vui--1pbqe6" }) `position:relative;height:100%;width:100%;z-index:1;`;
//# sourceMappingURL=styled.js.map